import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

import * as emailjs from 'emailjs-com';

// Material UI
import { withStyles } from 'material-ui/styles';

// Styles
import styles from './styles';

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

class Submit extends Component {

  constructor(props){
    super(props);

    this.state = {

    };
    this.handleYes = this.handleYes.bind(this);
  }

  handleYes = () => {
    //
    var candidate_id = getParameterByName('id');
    var message = "The candidate ID for review is : "+candidate_id;

    var templateParams = {
      message: message
    };

    emailjs.send('gmail', 'template_f5lwqZE5', templateParams, 'user_zt0wxz5CwlMoieSUTJew3').then(function(response) {
       console.log('SUCCESS!', response.status, response.text);
       alert("Thank you! This candidate has been noted and will be reviewed by someone on our team.")
       window.location.href = '/console/display/multi_folder_display/candidate_id/'+candidate_id;
    }, function(error) {
       console.log('FAILED...', error);
       alert("Thank you! This candidate has been noted and will be reviewed by someone on our team.")
       window.location.href = '/console/display/multi_folder_display/candidate_id/'+candidate_id;
    });
  }

  handleNo = () => {
    var candidate_id = getParameterByName('id');
    window.location.href = '/console/display/multi_folder_display/candidate_id/'+candidate_id;
  }

  render(){
    const { classes, location} = this.props;

    return(
      <div className={classes.root}>
        <Button raised color="secondary" onClick={() => this.handleYes()} align="center" className={classes.button}>YES</Button>
        <div className={classes.space}></div>
        <Button raised color="primary" onClick={() => this.handleNo()} align="center" className={classes.button}>NO</Button>
      </div>
    );
  }
}

Submit.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        email: state.email.email,
        password: state.password.password,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Submit)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/OARReport/components/CoreContent/components/Submit/index.js